<template>
  <section class="bg-gray-50 py-20 sm:py-28">
    <div class="container mx-auto px-4">
      
      <div class="flex justify-center lg:justify-end">
        
        <div class="max-w-xl text-center lg:text-left">
          
          <h1 class="text-4xl sm:text-5xl font-extrabold tracking-wide flex items-baseline justify-center lg:justify-start flex-wrap">
            <span class="text-black">OVER</span>
            <span class="text-orange-500">X</span>
            <span class="text-black text-4xl font-semibold relative mx-1">é</span>
            <span class="text-orange-500">funcionalidade</span>
          </h1>

          <p class="mt-6 text-base md:text-lg text-gray-700 leading-relaxed">
            A Overx é ideal para grandes redes de restaurantes, franquias de alimentação, PMEs do setor food e dark kitchens que precisam escalar com controle, inteligência e uma tecnologia que realmente acompanha o ritmo do negócio.
          </p>

          <div class="mt-10 flex flex-wrap gap-4 justify-center lg:justify-start">
            
            <a 
              v-for="button in downloadButtons" 
              :key="button.store" 
              :href="button.url" 
              target="_blank" 
              rel="noopener noreferrer"
              class="inline-flex items-center gap-4 bg-white border-2 border-orange-500 rounded-lg px-5 py-3 font-semibold text-gray-800 transition-all duration-300 hover:bg-orange-50 hover:shadow-lg hover:-translate-y-1"
            >
              <img :src="button.logoUrl" :alt="button.store + ' logo'" class="h-8 w-8 object-contain">
              
              <div class="flex flex-col text-left">
                <span class="text-xs leading-tight">{{ button.line1 }}</span>
                <span class="text-base leading-tight font-bold">{{ button.line2 }}</span>
              </div>
            </a>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DownloadSection',
  data() {
    return {
      downloadButtons: [
        {
          store: 'Play Store',
          line1: 'Baixe aqui no',
          line2: 'Play Store',
          url: 'https://play.google.com/store/apps/developer?id=OVER+X+TECNOLOGIA+LTDA&hl=pt_BR', 
          logoUrl: 'https://cdn-icons-png.flaticon.com/512/888/888857.png', 
        },
        {
          store: 'App Store',
          line1: 'Baixe aqui no',
          line2: 'App Store',
          url: 'https://apps.apple.com/br/developer/over-x-tecnologia-ltda/id1751007660',
          logoUrl: 'https://cdn-icons-png.flaticon.com/512/831/831276.png',
        },
        {
          store: 'Desktop',
          line1: 'Acesse pelo',
          line2: 'Desktop',
          url: 'https://marketplace.overx.com.br/search',
          logoUrl: 'https://cdn-icons-png.flaticon.com/512/8330/8330696.png',
        }
      ]
    }
  }
}
</script>